import axios from "axios";
import apiaxios from "../Utils/api";
import Cookies from "js-cookie";
import { useQuery } from "@tanstack/react-query";

// import { encryptRequest } from "../Utils/crypto";

const apiurl = process.env.REACT_APP_API_URL;


const checkonline = () => {
  return navigator.onLine;
};

// .............................................Fetch Dashboard data from api...............................................

// API fetchers
async function fetchdata() {
  try {
    const res = await apiaxios.post(
      `/GetDashboardData`,
      {},
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    console.log(`error is :`, error);
    return error;
  }
}

// Common query options
const defaultQueryOptions = {
  staleTime: 10 * 60 * 10000, // fresh for 10 minutes
  gcTime: 15 * 60 * 1000, // keep in cache (renamed from cacheTime in v5)
  refetchOnWindowFocus: false,
};

export const useDashboard = () =>
  useQuery({
    queryKey: ["dashboard"],
    queryFn: fetchdata,
    ...defaultQueryOptions,
  });

// Hook to get specific loan by opportunityId
export const useLoanByOpportunityId = (opportunityId) => {
  const dashboardQuery = useDashboard();
  const loan =
    dashboardQuery.data?.response?.status === "200"
      ? dashboardQuery.data.response.data.loanList.find(
          (loan) => loan.oppertunityId === opportunityId,
        )
      : null;

  return {
    ...dashboardQuery,
    loan,
  };
};

async function checkrepaymentschedulestatus() {
  try {
    const res = await apiaxios.post(
      `/checkrepaymentschedulestatus`,
      {},
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    console.error("Error checking repayment schedule status:", error);
    return error;
  }
}

export const useCheckRepaymentScheduleStatus = () =>
  useQuery({
    queryKey: ["CheckRepaymentScheduleStatus"],
    queryFn: checkrepaymentschedulestatus,
    ...defaultQueryOptions,
  });

export const getAccountSummary = async () => {
  try {
    const res = await apiaxios.post(`/getAccountSummary`, {});
    return res.data;
  } catch (error) {
    console.error("Error checking getAccountSummary :", error);
    return error;
  }
};

//...............................................Mobile Number verification api handling......................................
// async function verify_Mobile_Number(Mobile_Num, captchaToken) {
//   const checkinternetstatus = checkonline();
//   if (!checkinternetstatus) {
//     return {
//       response: {
//         status: "503",
//         message: "No internet connection. Please connect to the internet .",
//       },
//     };
//   } else {
//     try {
//       const res = await apiaxios.post(`${apiurl}/verify_Mobile_Number`, {
//         Mobile_Num,
//         captchaToken,
//       },
//       {withCredentials: true}
//     );
//       return res;
//     } catch (error) {
//       console.log(
//         `Exception while doing something in verify_Mobile_Number fun: ${error}`,
//       );
//       return;
//     }
//   }
// }

// shubham
async function verify_Mobile_Number(Mobile_Num, captchaToken) {
  if (!navigator.onLine) {
    return {
      response: {
        status: "503",
        message: "No internet connection. Please connect to the internet.",
      },
    };
  }

  try {
    // debugger
    const res = await apiaxios.post(
      `${apiurl}/verify_Mobile_Number`,
      {
        Mobile_Num,
        captchaToken,
      },
      {
        withCredentials: true,
      }
    );

    // ✅ IMPORTANT: res.data already decrypted hai
    return res;

  } catch (error) {
    console.log("API Error:", error);
    return error?.response;
  }
}

//...............................................Create and verify otp..................................................
// async function otp_verification(otpinput) {
//   const checkinternetstatus = navigator.onLine;
//   if (!checkinternetstatus) {
//     return {
//       status: "503",
//       message: "No internet connection. Please connect to the internet .",
//     };
//   } else {
//     try {
//       const response = await fetch(`${apiurl}/verify-otp`, {
//         method: "POST",
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(otpinput),
//       }).then((response) => response.json());
//       return response;
//     } catch (error) {
//       console.log(
//         `Exception while doing something in otp_verification fun: ${error}`,
//       );
//       return {
//         status: "401",
//         message: "Something went wrong . Please try again later! .",
//       };
//     }
//   }
// }

async function otp_verification(otpinput) {

  if (!navigator.onLine) {
    return {
      status: "503",
      message: "No internet connection. Please connect to the internet.",
    };
  }

  try {
    const res = await apiaxios.post(
      `${apiurl}/verify-otp`,
      otpinput,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    );

    // ✅ interceptor already decrypts
    return res.data;

  } catch (error) {
    console.log("OTP API Error:", error);

    return error?.response?.data || {
      status: "500",
      message: "Something went wrong. Please try again later!",
    };
  }
}

//.................................................Senf sms api Called.....................................................

async function send_sms(Mobile_Number) {
  const checkinternetstatus = checkonline();
  if (!checkinternetstatus) {
    return {
      status: "503",
      message: "No internet connection. Please connect to the internet .",
    };
  } else {
    try {
      const response = await apiaxios.post(`${apiurl}/send-sms`, {
        Mobile_Number,
      });
      return response;
    } catch (error) {
      console.log(`Exception while doing something in send_sms fun: ${error}`);
      window.location.href = "/";
      return;
    }
  }
}

//..................................................Send SMS from node mailer api called........................................
async function send_email({ email }) {
  try {
    const response = await apiaxios.post(`/sendemail`, { email });
    return response;
  } catch (error) {
    return error;
  }
}

// ..................................................Fetch profile data api called...............................................

async function fetchprofiledata() {
  try {
    const res = await apiaxios.post(
      `/GetProfileData`,
      {},
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    return error;
  }
}

export const useProfile = () =>
  useQuery({
    queryKey: ["profile"],
    queryFn: fetchprofiledata,
    ...defaultQueryOptions,
  });

// ..................................................update token...............................................
async function UpdateToken(
  OppertunityId,
  LoanType,
  LoanAccountNumber,
  FinOneLoanId,
) {
  try {
    const token = Cookies.get("token");
    const res = await apiaxios.post(`/UpdateToken`, {
      token,
      OppertunityId,
      LoanType,
      LoanAccountNumber,
      FinOneLoanId,
    });
    if (res) {
      Cookies.set("token", res.data.token);
      return { response: { status: "200", message: "Success ." } };
    }
  } catch (error) {
    return error;
  }
}

// ...................................................create lead for refer and earn api ..................
async function Referandearnleadcreation(data) {
  try {
    const payload = { data };
    const res = await apiaxios.post(`/Referandearnleadcreation`, payload, {
      withCredentials: true,
    });
    console.log(
      `response of  lead creation api in frontend index.js is ${JSON.stringify(res.data)}`,
    );
    return res.data;
  } catch (error) {
    return error;
  }
}

// ...................................................fetching and requesting new services....................................

async function raiseCommonServiceRequest(data) {
  try {
    const res = await apiaxios.post(
      `/Raise-Common-Service-Request`,
      { data },
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    return error;
  }
}

async function RepaymentSchedule(charge) {
  try {
    const res = await apiaxios.post(
      `/RepaymentSchedule`,
      { charge },
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    return error;
  }
}

async function Interest_Certificate(detail) {
  try {
    const res = await apiaxios.post(
      `/Interest_Certificate`,
      { detail },
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    return error;
  }
}

async function download_welcome_kit(requestStatus) {
  try {
    const res = await apiaxios.post(
      `/download_welcome_kit`,
      { requestStatus },
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    return error;
  }
}

async function E_Mandate(detail) {
  try {
    const res = await apiaxios.post(
      `/E_Mandate`,
      { detail },
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    return error;
  }
}

// ...............................................fetchservicerequeststatus...........................................

const loanapplicationdocumentApi = async () => {
  try {
    const res = await apiaxios.post(
      `/getLoanStatusDocuments`,
      {},
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    return error;
  }
};

// this map is used to set which service request would need to call dms api for document bringing from API
// write name of the button which is visible for customer
const serviceRequestDMSRequired = {
  "Health Insurance": true,
  "Critical Illness Insurance": true,
  "Property Insurance": true,
  "Life Insurance": true,
  "Interest Certificate": true,
  "Subsequent Disbursement Request": true,

  "E-Mandate": false,
  "Repayment Schedule": false,
  "Generate Welcome Kit": false,
  "Generate Statement of Accounts": false,
};

async function fetchServiceRequestStatusApiCallFun() {
  try {
    const serviceResponse = await apiaxios.post(
      `/Service-Request-Status`,
      {},
      { withCredentials: true },
    );

    // // we are calling DMS api only when we are submitting request as for checking status of status in request body of service request
    // if ( !isForStatusCheck && serviceRequestDMSRequired[serviceName]) {
    //     const documentResponse = await loanapplicationdocumentApi();

    //     // Create insurance mapping for document URLs
    //     const insuranceDocumentMap = {};

    //     // Check if document response has Insurance category
    //     if (documentResponse?.response?.data) {
    //         const insuranceCategory = documentResponse.response.data;

    //         if (insuranceCategory && insuranceCategory.subCategories) {
    //             // Create mapping for insurance documents
    //             insuranceCategory.subCategories.forEach(subCategory => {
    //                 if (
    //                     subCategory.status === 'Uploaded' &&
    //                     subCategory.documents &&
    //                     subCategory.documents.length > 0
    //                 ) {
    //                     // Map insurance subcategory names to their document URLs
    //                     const documentUrl =
    //                         subCategory.documents[0].NEILON__File_Presigned_URL__c;

    //                     // Handle the mapping based on your conditions
    //                     if (subCategory.name === 'Property Insurance') {
    //                         insuranceDocumentMap['Property Insurance'] = documentUrl;
    //                     } else if (subCategory.name === 'Interest Certificate') {
    //                         insuranceDocumentMap['Interest Certificate'] = documentUrl;
    //                     } else if (subCategory.name === 'Life Insurance') {
    //                         insuranceDocumentMap['Life Insurance'] = documentUrl;
    //                     } else if (subCategory.name === 'Critical Illness Premium') {
    //                         insuranceDocumentMap['Critical illness Insurance'] = documentUrl;
    //                     } else if (subCategory.name === 'Health Insurance Form') {
    //                         insuranceDocumentMap['Health Insurance'] = documentUrl;
    //                     } else if(subCategory.name === 'Disbursal Request') {
    //                         insuranceDocumentMap['Disbursal Request'] = documentUrl;
    //                     }else {
    //                         // No action for unmatched cases
    //                     }
    //                 }
    //             });
    //         }
    //     }

    //     // Modify the service response to include document URLs where applicable
    //     if (serviceResponse?.data?.response?.data) {
    //         serviceResponse.data.response.data = serviceResponse.data.response.data.map(
    //             (service) => {
    //                 // Check if this service request matches any insurance type
    //                 let updatedService = { ...service };

    //                  // Special case for 'Subsequent Disbursement'

    //                  if(service.requestName ==='Subsequent Disbursement'){
    //                      updatedService.documentURL =
    //                         insuranceDocumentMap['Disbursal Request'];
    //                 }else if (insuranceDocumentMap[service.requestName]) {
    //                     updatedService.documentURL =
    //                         insuranceDocumentMap[service.requestName];
    //                 }

    //                 return updatedService;
    //             },
    //         );
    //     }
    // }

    return serviceResponse.data;
  } catch (error) {
    return error;
  }
}

//...............................................For making protected routes.......................
async function checkprotectedroutes() {
  try {
    const res = await apiaxios.post(
      `/CheckProtectedRourtes`,
      {},
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    return error;
  }
}

// ...............................................Fetch payment history api called...........................................
async function fetchpaymenthistory(customerdetail) {
  try {
    const res = await apiaxios.post(`/Transaction-History`, {
      customerdetail: customerdetail,
    });
    return res.data;
  } catch (error) {
    console.log(
      `Exception while doing something in fetchpaymenthistory function: ${JSON.stringify(error)}`,
    );
    return error;
  }
}

// ...............................................Fetch-Banner Api Called...........................................
async function fetchbanner() {
  try {
    const res = await apiaxios.post(
      `/Fetch-Banner`,
      {},
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    return error;
  }
}
// ...............................................Fetch-Payment-Data...........................................
async function fetchpaymentdata() {
  try {
    const res = await apiaxios.post(
      `/Fetch-Payment-Data`,
      {},
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    return error;
  }
}

// ...............................................whatsup OPT-IN function to know its status................................
async function checkwhatsupopt() {
  try {
    const res = await apiaxios.post(
      `${apiurl}/OPT_Status`,
      {},
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    return error;
  }
}

// .................................................Toggle Whatsup Option..................................................
async function whatupotptoggle(customerdetail) {
  try {
    const res = await apiaxios.post(
      `/OPT_status_change`,
      { customerdetail: customerdetail },
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    return error;
  }
}

// .............................................................. Login ................................................................
async function Login(Mobile_Num, customerLocationDetails, otpToken) {
  try {
    const data = {
      Mobile_Num,
      customerLocationDetails,
    };

    //  const encryptedPayload = await encryptRequest(data);
    // const res = await axios.post(`${apiurl}/Login`, data, { withCredentials: true });

    // shubham

    const res = await apiaxios.post(`/Login`, data, {
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${otpToken}`, 
      },
    });

    // console.log(` Response of Login ${JSON.stringify(res)}`);
    if (res.status == 201) {
      return { status: 201, message: "session Created successfully!" };
    } else {
      return false;
    }
  } catch (error) {
    return error;
  }
}

// ............................................................ Fetch Account Detail Function.........................................................................

async function FetchAccountDetail() {
  try {
    const res = await apiaxios.post(
      `/FetchAccountDetail`,
      {},
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    return error;
  }
}

export const useFetchAccountDetail = () =>
  useQuery({
    queryKey: ["fetchaccountdetail"],
    queryFn: FetchAccountDetail,
    ...defaultQueryOptions,
  });

// ....................................................Notification Api ............................................
async function FetchNotificationData(Mobile) {
  try {
    const res = await apiaxios.post(`/GetNotificationData`, { Mobile });
    return res.data;
  } catch (error) {
    return error;
  }
}

// ..........................................................getstatementcharges..........................

async function getstatementcharges() {
  try {
    const res = await apiaxios.post(`/getstatementcharges`);
    return res.data;
  } catch (error) {
    return error;
  }
}

//............................SIdebar Data.......................///
async function fetchSidebarData() {
  const checkinternetstatus = !navigator.onLine;
  if (!checkinternetstatus) {
    return {
      response: {
        status: "503",
        message: "No internet connection. Please connect to the internet .",
      },
    };
  } else {
    try {
      const res = await axios.get(`${apiurl}/getSidebarData`);
      return res.data;
    } catch (error) {
      return error;
    }
  }
}

// ............................ Interest Rate movement...................

async function fetchInterestRateMovement(Disbursementdate, roi) {
  try {
    const res = await apiaxios.post(
      `/getInterestRateMovement`,
      {},
      { withCredentials: true },
    );
    if (res.data.response.status == "200") {
      const responseofapi = res.data.response.data;
      const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        return date.toLocaleDateString("en-US", options).toUpperCase();
      };

      const rateOfMovement = [];
      let currentRate = null;
      let startDate = Disbursementdate;
      if (responseofapi.length == 0 && roi != null) {
        rateOfMovement.push({
          content: `${roi}%`,
          start_date: formatDate(startDate),
          end_date: "Present",
        });
      } else {
        responseofapi.forEach((entry) => {
          const newRate = entry.newRate;

          // Check if the rate has changed
          if (newRate !== currentRate) {
            if (currentRate == null) {
              rateOfMovement.push({
                content: `${entry.oldRate}%`,
                start_date: formatDate(startDate),
                end_date: formatDate(entry.reschedulingDate),
              });
            }

            if (currentRate !== null) {
              rateOfMovement.push({
                content: `${currentRate}%`,
                start_date: formatDate(startDate),
                end_date: formatDate(entry.reschedulingDate),
              });
            }

            // Update current rate and start date
            currentRate = newRate;
            startDate = entry.reschedulingDate;
          }
        });
        // Push the last rate change if it exists
        if (currentRate !== null) {
          rateOfMovement.push({
            content: `${currentRate}%`,
            start_date: formatDate(startDate),
            end_date: "Present",
          });
        }
      }
      return {
        response: {
          status: "200",
          rateofmovement: [...rateOfMovement].reverse(),
        },
      };
    } else {
      return res.data;
    }
  } catch (error) {
    return error;
  }
}

//..............................Fetch Provisional Interest data...............
async function fetchProvisionalInterestData() {
  try {
    const res = await apiaxios.post(
      `/getProvisionalInterestData`,
      {},
      { withCredentials: true },
    );
    let principalAmount = 0;
    let interestAmount = 0;
    if (res.data.response.data.length === 0 || res.data.response.length === 0) {
      return { response: { status: "200", meassge: "NO DATA FOUND!" } };
    } else if (
      res.data.response.data.provisionresponse.length > 0 ||
      res.data.response.data.length > 0
    ) {
      res.data.response.data.provisionresponse.forEach((element) => {
        principalAmount += parseFloat(element.principleamount) || 0;
        interestAmount += parseFloat(element.interestamount) || 0;
      });
    }
    principalAmount = parseFloat(principalAmount.toFixed(2));
    interestAmount = parseFloat(interestAmount.toFixed(2));
    const receivedprincipal = res.data.response.data.receivedprincipal;
    const receivedinterest = res.data.response.data.receivedinterest;

    return {
      response: {
        status: "200",
        message: "Success",
        data: {
          principalAmount,
          interestAmount,
          receivedinterest,
          receivedprincipal,
        },
      },
    };
  } catch (error) {
    return error;
  }
}

// .......................Fetch transaction details for table....................
async function fetchTransactionDetails(value) {
  try {
    const res = await apiaxios.post(
      `/fetchpreviousTransactionDeatils`,
      { value: value },
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    return error;
  }
}

function toCamelCase(name) {
  return name
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

const formatDate = (dateString) => {
  if (dateString === null || dateString === "") {
    return;
  }
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

// for IST
function convertUTCToIST(utcDateString) {
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.000Z$/.test(utcDateString)) {
    throw new Error(
      "Invalid date format. Expected format: YYYY-MM-DDTHH:MM:SS.000Z",
    );
  }

  const utcDate = new Date(utcDateString);

  if (isNaN(utcDate.getTime())) {
    throw new Error("Invalid date value");
  }

  const day = String(utcDate.getDate()).padStart(2, "0");
  const month = String(utcDate.getMonth() + 1).padStart(2, "0");
  const year = utcDate.getFullYear();
  const hours = utcDate.getHours();
  const minutes = String(utcDate.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = String(hours % 12 || 12).padStart(2, "0");
  return `${day}-${month}-${year} ${formattedHours}:${minutes} ${ampm}`;
}

//.....................................fetch tenure data..................................

async function fetchTenureData() {
  try {
    const res = await apiaxios.post(
      `/fetchTenureData`,
      {},
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    console.log(`error in fetch tenure data ${error}`);
    throw error;
  }
}

export const useTenureData = () =>
  useQuery({
    queryKey: ["tenureData"],
    queryFn: fetchTenureData,
    ...defaultQueryOptions,
  });

//...................................... fetch payment status from db........................
async function fetchpaymentstatus(opportunityId) {
  try {
    const res = await apiaxios.post(
      `/fetchpaymentstatus`,
      { opportunityId },
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    return error;
  }
}

async function fetchpaymentstatusforpaymentpopup(txnid) {
  try {
    const res = await apiaxios.post(
      `/fetchpaymentstatusforpaymentpopup`,
      { txnid },
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    return error;
  }
}

//.................................change payment status in db...........................
async function updatetransactionstatus(txnID) {
  const checkinternetstatus = !navigator.onLine;
  if (!checkinternetstatus) {
    return {
      response: {
        status: "503",
        message: "No internet connection. Please connect to the internet.",
      },
    };
  } else {
    try {
      const res = await axios.post(
        `${apiurl}/changeflag`,
        { txnID },
        { withCredentials: true },
      );
      return { response: { status: "200", data: res.data } };
    } catch (error) {
      console.error(
        "Error fetching provisional updatetransactionstatus data:",
        error,
      );
      return {
        response: {
          status: "500",
          message: "Something went wrong. Please try again later!",
        },
      };
    }
  }
}

function formatDateTime(dateTime) {
  const date = new Date(dateTime);

  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();

  const istOffset = 5.5 * 60 * 60 * 1000;
  const istDate = new Date(date.getTime() + istOffset);

  const hours = istDate.getHours();
  const minutes = String(istDate.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = String(hours % 12 || 12).padStart(2, "0");

  const formattedDate = `${day}-${month}-${year}`;
  const formattedTime = `${formattedHours}:${minutes} ${ampm}`;

  return `${formattedDate} ${formattedTime}`;
}

async function handleDirectGenerate(fromdate, todate, paymentData) {
  const data = {
    fromDate: fromdate,
    toDate: todate,
    amount: paymentData,
  };
  try {
    const res = await apiaxios.post(`/directgenerate`, { data });
    return res.data;
  } catch (error) {
    return error;
  }
}

function formatToIndianRupees(amount) {
  if (isNaN(amount)) return "Invalid amount";

  const formatted = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(amount);

  return formatted.replace("₹", "₹ ");
}

//......................................for loan detail list.........................
async function loanDetailList() {
  try {
    const res = await apiaxios.post(
      `/getLoanDetailList`,
      {},
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    return error;
  }
}

// insert commas in number
function insertCommas(input) {
  if (input === null || input === undefined) {
    return "0";
  }
  const num = parseInt(input);
  if (isNaN(num)) {
    return "0";
  }
  return num.toLocaleString("en-IN");
}

async function WebToCaseSubmit(formData) {
  try {
    const res = await apiaxios.post(
      `/WebToCaseSubmit`,
      { formData },
      { withCredentials: true },
    );
    console.log(
      `Data received from WebToCaseSubmit : ${JSON.stringify(res.data)}`,
    );
    return res.data;
  } catch (error) {
    return error;
  }
}
// fetch dashboard api data with mobile no
async function fetchdata2(mobileNum) {
  try {
    const res = await apiaxios.post(`/GetDashboardData2`, { mobileNum });
    return res.data;
  } catch (error) {
    return error;
  }
}

async function sendwebtocasebackend(senddataforbackend) {
  try {
    const res = await apiaxios.post(
      `/webtocasebackend`,
      { senddataforbackend },
      { withCredentials: true },
    );
    return res.data;
  } catch (error) {
    console.log(
      `Exception while doing something in fetchdata function: ${JSON.stringify(error.response)}`,
    );
    return error;
  }
}

async function setActivity(url) {
  try {
    await apiaxios.post(`/setActivity`, { url });
  } catch (error) {
    return error;
  }
}

async function getdata() {
  try {
    const res = await apiaxios.post(`${apiurl}/Getdata`, {});
    return res.data;
  } catch (error) {
    return error;
  }
}

const handleDownloadDocument = async (url) => {
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "*/*",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const arrayBuffer = await response.arrayBuffer();

    let contentType = response.headers.get("content-type");

    if (
      !contentType ||
      contentType === "application/octet-stream" ||
      contentType === "text/plain"
    ) {
      contentType = detectFileTypeFromBuffer(arrayBuffer, url);
    }

    let filename = "document";

    const contentDisposition = response.headers.get("content-disposition");
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(
        /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
      );
      if (filenameMatch) {
        filename = filenameMatch[1].replace(/['"]/g, "");
      }
    }

    if (filename === "document") {
      try {
        const urlObj = new URL(url);
        const pathname = urlObj.pathname;

        const urlFilename = pathname.split("/").pop();

        if (urlFilename && urlFilename.trim() !== "") {
          const decodedFilename = decodeURIComponent(urlFilename).split("?")[0];
          if (decodedFilename.includes(".")) {
            filename = decodedFilename;
          } else {
            const extension = getExtensionFromContentType(contentType);
            filename = decodedFilename + extension;
          }
        }
      } catch (urlError) {
        console.warn("Error parsing URL:", urlError);
        const urlParts = url.split("/");
        const urlFilename = urlParts[urlParts.length - 1];
        if (urlFilename && urlFilename.includes(".")) {
          filename = decodeURIComponent(urlFilename.split("?")[0]);
        }
      }
    }

    if (filename === "document") {
      const extension = getExtensionFromContentType(contentType);
      filename = `document${extension}`;
    }

    if (!filename.includes(".")) {
      const extension = getExtensionFromContentType(contentType);
      filename = filename + extension;
    }

    const fileBlob = new Blob([arrayBuffer], { type: contentType });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(fileBlob);
    link.download = filename;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => {
      URL.revokeObjectURL(link.href);
    }, 100);
  } catch (error) {
    console.error("Download failed:", error);
    window.open(url, "_blank");
  }
};

// Helper function to detect file type from buffer content
const detectFileTypeFromBuffer = (arrayBuffer, url) => {
  const uint8Array = new Uint8Array(arrayBuffer);

  // Checking PDF signature
  if (uint8Array.length >= 4) {
    const pdfSignature = String.fromCharCode(...uint8Array.slice(0, 4));
    if (pdfSignature === "%PDF") {
      return "application/pdf";
    }
  }

  // Checking PNG signature
  if (uint8Array.length >= 8) {
    const pngSignature = [137, 80, 78, 71, 13, 10, 26, 10];
    const isPNG = pngSignature.every(
      (byte, index) => uint8Array[index] === byte,
    );
    if (isPNG) {
      return "image/png";
    }
  }

  // Checking JPEG signature
  if (uint8Array.length >= 3) {
    if (
      uint8Array[0] === 0xff &&
      uint8Array[1] === 0xd8 &&
      uint8Array[2] === 0xff
    ) {
      return "image/jpeg";
    }
  }

  // Fallback
  const urlLower = url.toLowerCase();
  if (urlLower.includes(".pdf")) return "application/pdf";
  if (urlLower.includes(".png")) return "image/png";
  if (urlLower.includes(".jpg") || urlLower.includes(".jpeg"))
    return "image/jpeg";
  if (urlLower.includes(".webp")) return "image/webp";
  if (urlLower.includes(".svg")) return "image/svg+xml";

  // Default fallback
  return "application/octet-stream";
};

// Helper function to get file extension from content type
const getExtensionFromContentType = (contentType) => {
  const mimeTypes = {
    "application/pdf": ".pdf",
    "image/png": ".png",
    "image/jpeg": ".jpg",
    "image/jpg": ".jpg",
    "image/gif": ".gif",
    "image/webp": ".webp",
    "image/svg+xml": ".svg",
    "text/plain": ".txt",
    "application/msword": ".doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      ".docx",
    "application/vnd.ms-excel": ".xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      ".xlsx",
    "application/octet-stream": "",
  };

  return mimeTypes[contentType] || "";
};

//........................................... encryption and decryption of mobile number in url for web to case........................

export {
  checkonline,
  fetchdata,
  checkrepaymentschedulestatus,
  fetchprofiledata,
  raiseCommonServiceRequest,
  fetchServiceRequestStatusApiCallFun,
  loanapplicationdocumentApi,
  fetchpaymenthistory,
  fetchbanner,
  fetchpaymentdata,
  checkwhatsupopt,
  whatupotptoggle,
  Login,
  UpdateToken,
  FetchAccountDetail,
  Referandearnleadcreation,
  FetchNotificationData,
  verify_Mobile_Number,
  send_sms,
  otp_verification,
  send_email,
  checkprotectedroutes,
  getstatementcharges,
  fetchSidebarData,
  fetchInterestRateMovement,
  fetchProvisionalInterestData,
  fetchTransactionDetails,
  fetchTenureData,
  formatDate,
  formatDateTime,
  updatetransactionstatus,
  fetchpaymentstatus,
  toCamelCase,
  convertUTCToIST,
  handleDirectGenerate,
  formatToIndianRupees,
  loanDetailList,
  insertCommas,
  WebToCaseSubmit,
  fetchdata2,
  sendwebtocasebackend,
  fetchpaymentstatusforpaymentpopup,
  setActivity,
  getdata,
  RepaymentSchedule,
  Interest_Certificate,
  download_welcome_kit,
  E_Mandate,
  handleDownloadDocument,
};